// extracted by mini-css-extract-plugin
export default {"accessContainer":"style_accessContainer__qxmN5","accessContent":"style_accessContent__2qWUq"};